import Link from 'next/link'

import styles from './Footnote.module.scss'

export default function FootNote() {
  return (
    <div className={styles.wrapper}>
      <p className={styles.heading}>Get Started with Shopify</p>
      <p>
        Looking to get started with Shopify? Take advantage of Shopify's 14-day
        free trial, no credit card is required.
      </p>

      <p>
        If you're actively looking to work with a Shopify agency designer or
        developer to assist you with your business, we'd love to hear from you.{' '}
        <Link href="/contact" title="Contact Karmoon" prefetch={false}>
          Get in touch
        </Link>{' '}
        to get started!
      </p>
    </div>
  )
}
